module.exports = __webpack_public_path__ + "img/physio_stats.f90d5b0a.png";